module.exports = __webpack_public_path__ + "static/cupcakes-d8b4893a21b3107796e1e1818898e342.png";